export default __webpack_public_path__ + "static/media/self-delivery-method-setup.c9a32bc1.png";